import React from "react";
import useWindowDimensions from "../utils/useWindowDimensions";
import EvaluationsM from "./Mobile/evaluations/evaluationsM";
import EvaluationsPc from "./Pc/evaluations/evaluationsPc";
import {widthMobile} from "../utils/constants"

const Evaluations = (props) => {
    const {width} = useWindowDimensions();
    const IsMobile = width < widthMobile;
    return IsMobile ? <EvaluationsM {...props} /> : <EvaluationsPc {...props} />;
}
export default Evaluations;